import { render, staticRenderFns } from "./customPeriod.vue?vue&type=template&id=280e1172&scoped=true"
import script from "./customPeriod.vue?vue&type=script&lang=js"
export * from "./customPeriod.vue?vue&type=script&lang=js"
import style0 from "./customPeriod.vue?vue&type=style&index=0&id=280e1172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e1172",
  null
  
)

export default component.exports